import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Avatar, Dropdown } from 'antd';
import { BarihausLayout, Content } from '@bancobarigui/barihaus';
import { UserOutlined } from '@ant-design/icons';

import { useProtectedRouteContainer } from './useProtectedRouteContainer.tsx';
import { useBreadcrumbs } from './useBreadcrumbs';
import { NotificationButton } from '../NotificationButton';
import { ReportsModal } from '../ReportsModal';
import { useAuth } from '@/contexts/auth.context';
import LogoLight from '@/assets/logo-averix-light.svg';
import IconeLight from '@/assets/icone-averix-light.svg';

type Props = {
  children: ReactNode;
  pageHeader?: ReactNode;
};

export function ProtectedRouteContainer({ children, pageHeader }: Props) {
  const {
    onClickMenu,
    menuItems,
    dropDownItems,
    isReportsModalOpen,
    handleCloseReportsModal,
    handleExportPanorama,
    isExporting,
  } = useProtectedRouteContainer();
  const { user } = useAuth();
  const breadcrumbItems = useBreadcrumbs();

  const renderedBreadcrumbs = breadcrumbItems.map((item) => ({
    ...item,
    title: item.href ? (
      <Link to={item.href} className="hover:underline">
        {item.title}
      </Link>
    ) : (
      item.title
    ),
  }));

  return (
    <>
    <style>{`
      .ant-layout-sider img[src*="bancobari.com.br"] {
        content: url(${LogoLight});
      }
      .ant-layout-sider.ant-layout-sider-collapsed img[src*="bancobari.com.br"] {
        content: url(${IconeLight});
      }
      .ant-layout-header .ant-breadcrumb {
        padding-left: 24px;
      }
    `}</style>
    <BarihausLayout
      menuItems={menuItems}
      onMenuClick={onClickMenu}
      siderWidth={280}
      breadcrumbItems={breadcrumbItems.length > 2 ? renderedBreadcrumbs : undefined}
      headerContent={
        <div className="flex items-center gap-3">
          <NotificationButton />
          <Dropdown
            menu={{ items: dropDownItems }}
            dropdownRender={(menu) => (
              <div className="bg-white rounded-lg shadow-lg">
                <div className="px-4 py-3 border-b border-gray-200">
                  <div className="font-semibold text-gray-900">{user?.name || 'Usuário'}</div>
                  <div className="text-sm text-gray-500">{user?.email || ''}</div>
                </div>
                {menu}
              </div>
            )}
          >
            <Avatar
              icon={<UserOutlined />}
              src={user?.photoUrl}
              className="cursor-pointer"
            />
          </Dropdown>
        </div>
      }
    >
      <Content className="flex flex-col w-full mt-0">
        {pageHeader}
        <div className="rounded-xl bg-white flex flex-col w-full p-6">
          {children}
        </div>
      </Content>
      <ReportsModal
        open={isReportsModalOpen}
        onClose={handleCloseReportsModal}
        onExportPanorama={handleExportPanorama}
        isExporting={isExporting}
      />
    </BarihausLayout>
    </>
  );
}
